import React from 'react'
import Laptop from '../../../assets/svgs/Laptop.svg'
import Mobile from '../../../assets/svgs/Mobile.svg'
import SimpleIconCard from '../../cards/SimpleIconCard'

const DynamicMarketing = () => {
    const cardData = [
        {
            header: 'Command Center',
            text: 'The central command center allows for effortless campaign configuration and real-time results analysis.',
            icon: Laptop
        },
        {
            header: 'Mobile App',
            text: 'Our intuitive app ensures you can refine targeting, adjust budgets, and deploy ads on the go, keeping your users agile and informed wherever you are.',
            icon: Mobile
        }
    ]


    return (
        <section className='bg-brandPurple py-20 px-8 sm:px-58px] md:px-[68px] lg:px-[90px] xl:px-32'>
            <p className='text-white headerText2 text-center mb-16 lg:mb-[120px]'>Your marketing needs to be as dynamic as the market itself. Achieve market and brand mastery with extensive controls and a mobile-first user experience.</p>
            <div className='grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-16'>
                {
                    cardData.map((card, idx) => {
                        return (
                            <SimpleIconCard
                                cardHeader={card.header}
                                cardText={card.text}
                                cardIcon={card.icon}
                                key={idx}
                            />
                        )
                    })
                }
            </div>
        </section>
    )
}

export default DynamicMarketing